import React, {useState, useRef} from "react";
import { Select } from 'antd';
import SelectArrow from '../Common/SelectArrow/SelectArrow';
import './Comparator.css';
import ComparatorSearcherResults from "./ComparatorSearcherResults";
import { useQuerySearcher } from "../../hooks/searcher/useQuerySearcher";
import { useEffect } from "react";
import { useSearchParams, useSearchParamsDispatch } from "../../context/SearchParamsContext";

const ComparatorSearcher = (props) => {
    const [loadedFundList, setLoadedFundList] = useState([]);
    const [hasSearched, setHasSearched] = useState(false);
    const searchParamsState = useSearchParams();
    const searchParamsDispatch = useSearchParamsDispatch();
    const { queryFilters, loading, searchResults } = searchParamsState;

    const inputRef = useRef(null);

    const optionsData = [
        {
            value: 'fondos',
            label: 'Fondos de inversión'
        },
        {
            value: 'planesPensiones',
            label: 'Planes de pensiones'
        },
        {
            value: 'epvs',
            label: 'EPSVS'
        },
        {
            value: 'ASOCIADO',
            label: 'Planes asociados'
        }
    ];

    const { handleSearch } = useQuerySearcher();
    const handleSearchSubmit = async() => {
        await handleSearch();
        setLoadedFundList([]);
        setHasSearched(true);
    };

    useEffect(() => {
        searchParamsDispatch({ queryFilters: { ...queryFilters, tipo: "fondos" } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const formFieldFocus = () => {
            inputRef?.current.focus();
        };
    
        props.comparatorPageRef?.current?.addEventListener('formFieldFocusEvent', formFieldFocus);
    
        return () => {
            props.comparatorPageRef?.current?.removeEventListener('click', formFieldFocus);
        };
    }, [props.comparatorPageRef, inputRef]);

    useEffect(() => {
        if (hasSearched) setLoadedFundList(searchResults);
    }, [searchResults, hasSearched]);

    return (
        <section className="comparator-searcher wrapper-search justify-content-center" style={{paddingRight: 50, paddingLeft: 50}}>
            <div className='d-flex flex-row justify-content-center'>
                <div className="flex-fill">
                    <section className="wrapper-search container">
                        <div className="button-box" style={{maxWidth: 'inherit', textAlign: 'left', padding: '40px 10% 40px 10%'}}>
                            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                                <span className="blueText" style={{fontWeight: 600, fontSize: 16, marginBottom: 20}}>Selecciona el tipo de producto a comparar</span>
                                {/* <span style={{fontSize: '14px', fontWeight: 500, color: 'red'}}>Limpiar búsqueda</span> */}
                            </div>
                            <div className='search-content search-center-dropdown main-search'>
                                <div>
                                    <Select
                                        defaultValue="fondos"
                                        style={{ width: '100%', outline: '0px', maxWidth: '200px', marginRight: 40}}
                                        loading={false}
                                        options={optionsData}
                                        suffixIcon={<SelectArrow />}
                                        onSelect={(e) => searchParamsDispatch({ queryFilters: { ...queryFilters, tipo: e } })}
                                        bordered={false}
                                    >
                                    </Select>
                                </div>
                                <div className='flex-fill'>
                                    <input ref={inputRef} style={{fontSize: '1rem', border: '0px'}} type='text' className='form-control' placeholder='Busca por nombre o código' onChange={(e) => searchParamsDispatch({querySearch: e.target.value})}/>
                                </div>
                                <div className='spyglassSearch' onClick={handleSearchSubmit}>
                                    <i className="fa-solid fa-magnifying-glass"></i>
                                </div>
                                <ComparatorSearcherResults
                                    isLoading={loading}
                                    loadedFundList={loadedFundList}
                                    setComparatorSlot={props.setComparatorSlot}
                                    inputRef={inputRef}
                                    />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </section>
    );
};

export default ComparatorSearcher;
